import { createSlice } from '@reduxjs/toolkit';
import { portalUserInfo, userInfo } from './actions';
const initialState = {
  isLoading: false,
  portal: {
    portalId: 0,
    hublet: '',
    accountName: '',
    enabledGates: [],
    scopes: [],
    locale: {
      locale: '',
      langEnabled: false
    },
    timeZone: {
      id: '',
      offset: 0
    }
  },
  user: {
    userId: 0,
    email: '',
    firstName: '',
    lastName: '',
    enabledGates: [],
    locale: {
      locale: '',
      langEnabled: false
    }
  },
  tokenInfo: {
    scopeGroups: []
  },
  currentAccount: {}
};
const auth = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    getAppContextFailed: state => {
      state.isLoading = false;
    }
  },
  extraReducers: builder => {
    builder.addCase(portalUserInfo.pending, (state, action) => {
      if (!action.meta.arg) state.isLoading = true;
    });
    builder.addCase(portalUserInfo.rejected, state => {
      state.isLoading = false;
    });
    builder.addCase(portalUserInfo.fulfilled, (state, action) => {
      if (action.payload) {
        return Object.assign({}, state, action.payload, {
          isLoading: false,
          currentAccount: {
            accountName: action.payload.portal.accountName,
            hublet: action.payload.portal.hublet,
            id: action.payload.portal.portalId
          }
        });
      }
      return state;
    });
    builder.addCase(userInfo.fulfilled, (state, action) => {
      state.user = action.payload;
    });
  }
});
export const authActions = auth.actions;
export default auth.reducer;